import * as React from 'react'

const SvgPluginIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_4241_88192)">
      <path
        d="M17.0241 10.5465H18.7802C19.082 10.5465 19.3267 10.3018 19.3267 10V4.73176C19.3267 4.42994 19.082 4.18526 18.7802 4.18526H14.0584V2.97568C14.0584 1.70601 13.0255 0.673096 11.7558 0.673096C10.4862 0.673096 9.45326 1.70605 9.45326 2.97568V4.18526H4.73151C4.4297 4.18526 4.18501 4.42994 4.18501 4.73176V9.4535H2.97543C1.70581 9.4535 0.672852 10.4865 0.672852 11.7561C0.672852 13.0257 1.70581 14.0587 2.97543 14.0587H4.18501V18.7804C4.18501 19.0822 4.4297 19.3269 4.73151 19.3269H9.99976C10.3016 19.3269 10.5463 19.0822 10.5463 18.7804V17.0243C10.5463 16.3573 11.0889 15.8147 11.7558 15.8147C12.4228 15.8147 12.9654 16.3574 12.9654 17.0243V18.7804C12.9654 19.0822 13.2101 19.3269 13.5119 19.3269H18.7802C19.082 19.3269 19.3267 19.0822 19.3267 18.7804V13.5122C19.3267 13.2103 19.082 12.9657 18.7802 12.9657H17.0241C16.3571 12.9657 15.8145 12.423 15.8145 11.7561C15.8145 11.0891 16.3571 10.5465 17.0241 10.5465ZM17.0241 14.0587H18.2337V18.2339H14.0584V17.0243C14.0584 15.7547 13.0255 14.7217 11.7558 14.7217C10.4862 14.7217 9.45326 15.7547 9.45326 17.0243V18.2339H5.27801V13.5122C5.27801 13.2103 5.03333 12.9657 4.73151 12.9657H2.97543C2.30845 12.9657 1.76585 12.423 1.76585 11.7561C1.76585 11.0891 2.30848 10.5465 2.97543 10.5465H4.73151C5.03333 10.5465 5.27801 10.3018 5.27801 10V5.27825H9.99976C10.3016 5.27825 10.5463 5.03357 10.5463 4.73176V2.97568C10.5463 2.30869 11.0889 1.76609 11.7558 1.76609C12.4228 1.76609 12.9654 2.30873 12.9654 2.97568V4.73176C12.9654 5.03357 13.2101 5.27825 13.5119 5.27825H18.2337V9.4535H17.0241C15.7544 9.4535 14.7215 10.4865 14.7215 11.7561C14.7215 13.0257 15.7544 14.0587 17.0241 14.0587Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_4241_88192">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default SvgPluginIcon
